module.exports = __webpack_public_path__ + "img/AlmaLinux.d2fe2a9.svg";